module.exports = __webpack_public_path__ + "4be0742bd4547a2c45459dd9ab39dde4.png";